import React, { FC, useState, useEffect } from 'react';
import JsonData from '../data/skills.json';
import { TypeProps } from "./types";

const Skills:FC<TypeProps> = ({content}) => {
    const [skills, setSkills] = useState<string[]>([]);
    useEffect(() => {
        const data = JsonData;
        if(Object.keys(data).includes(content)) {
            setSkills(data[content as keyof typeof data]);
        }
        else {
            console.error(`'${content}' is not allowed`);
        }
        // eslint-disable-next-line
    }, []);

    return (
        <ul>
            {
                skills.map((skill, idx) => (<li key={idx}>{skill}</li>))
            }
        </ul>
    );
};

export default Skills;